import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  menuListItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuItem: {
    maxHeight: 30,
  },
  queueSelectContainer: {
    width: '100%',
    minWidth: 140,
    marginTop: 0,
    marginRight: 0,
    display: 'flex',
    alignItems: 'center',
  },
  selectRoot: {
    borderRadius: 8,
    height: 30,
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "transparent",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.2)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.type === "light" ? theme.palette.primary.main : "rgba(255, 255, 255, 0.5)",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.type === "light" ? theme.palette.primary.main : "rgba(255, 255, 255, 0.7)",
    },
    "& .MuiSelect-select": {
      padding: "5px 28px 5px 10px !important",
      fontSize: "0.80rem",
      fontWeight: 500,
      color: theme.palette.type === "light" ? "#334155" : "inherit",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
}));

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const classes = useStyles();

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={classes.queueSelectContainer}>
      <FormControl fullWidth margin="dense" style={{ margin: 0 }}>
        <Select
          multiple
          displayEmpty
          variant="outlined"
          value={selectedQueueIds}
          onChange={handleChange}
          className={classes.selectRoot}
          style={{
            borderRadius: 8,
            height: 30,
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                borderRadius: "0 0 8px 8px",
              },
            },
            MenuListProps: {
              className: classes.menuListItem,
            },
          }}
          renderValue={(selected) => {
            if (!selected || selected.length === 0) {
              return i18n.t("ticketsQueueSelect.placeholder");
            }
            const selectedQueues = userQueues?.filter((q) =>
              selected.includes(q.id) || selected.includes(Number(q.id)) || selected.includes(String(q.id))
            ) || [];
            if (selectedQueues.length === 0) {
              return i18n.t("ticketsQueueSelect.placeholder");
            }
            return selectedQueues.map((q) => q.name).join(", ");
          }}
        >
          {userQueues?.length > 0 &&
            userQueues.map((queue) => (
              <MenuItem
                dense
                key={queue.id}
                value={queue.id}
                className={classes.menuItem}
              >
                <Checkbox
                  style={{
                    color: queue.color,
                  }}
                  size="small"
                  color="primary"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <ListItemText
                  primary={queue.name}
                  classes={{ primary: classes.listItemText }}
                />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsQueueSelect;
